import {useCallback} from 'react';

import storage from 'store/localStorage';

const version = storage.getItem('version');

const useMigration5to6 = () => {

    // Fabric.js v6 migration: Ensure all text objects have text property
    return useCallback(() => {

        if (version >= 6) {
            console.log('Migration5to6: already migrated to version 6');
            return;
        }

        console.log('Migration5to6: migrating to version 6 (Fabric.js v6 compatibility)');

        // Get all sheet IDs from localStorage
        const sheetsData = storage.getItem('sheets');
        if (sheetsData && Array.isArray(sheetsData)) {
            sheetsData.forEach(sheet => {
                const sheetKey = `sheet_${sheet.id}`;
                const sheetData = storage.getItem(sheetKey);
                
                if (sheetData && sheetData.canvas && sheetData.canvas.objects) {
                    // Remove all undefined properties from an object
                    const removeUndefinedProps = (obj) => {
                        if (!obj || typeof obj !== 'object') return;
                        
                        Object.keys(obj).forEach(key => {
                            if (obj[key] === undefined) {
                                delete obj[key];
                            } else if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                                removeUndefinedProps(obj[key]);
                            }
                        });
                    };

                    // Recursively fix text objects
                    const fixTextObjects = (obj) => {
                        if (!obj) return;
                        
                        // First, remove all undefined properties
                        removeUndefinedProps(obj);
                        
                        if (obj.type === 'textbox' || obj.type === 'text' || obj.type === 'i-text' || obj.type === 'fabrictext' || obj.type === 'Text') {
                            if (obj.text === undefined || obj.text === null) {
                                obj.text = '';
                            }

                            if (obj.fontSize === undefined) obj.fontSize = 40;
                            if (obj.fontFamily === undefined) obj.fontFamily = 'Arial';
                            
                            // Fabric.js v7: defaults are center/center
                            if (obj.originX === undefined) obj.originX = 'center';
                            if (obj.originY === undefined) obj.originY = 'center';
                        }
                        
                        if (obj.objects && Array.isArray(obj.objects)) {
                            obj.objects.forEach(nestedObj => fixTextObjects(nestedObj));
                        }
                    };

                    sheetData.canvas.objects.forEach(obj => fixTextObjects(obj));
                    storage.setItem(sheetKey, sheetData);
                }
            });
        }

        storage.setItem('version', 6);
        console.log('Migration5to6: completed');

        // do not re-render/generate, runs at startup only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useMigration5to6;